/**
 * EventEmitter library custom build for ClientJS
 * @module
 */
var _ = require('optimizely-client-fn');
var uuid = require('optimizely-uuid');

var actionTypes = require('../constants/action_types');
var ApiEvents = require('../api_events');
var di = require('../di');
var Flux = require('../flux');
var Logger = require('../utils/logger');

var EventEmitterStore = di.get('stores/event_emitter');

/**
 * Adds an event listener
 * @param {EventListenerConfig} options
 * @return {string} token
 */
exports.on = function(options:EventListenerConfig): string {
  if (!options.token) {
    options.token = uuid.generate();
  }

  Flux.dispatch(actionTypes.ADD_EMITTER_HANDLER, options);

  return options.token;
};

/**
 * Removes an event handler by token
 * @param {string} token
 */
exports.off = function(token:string) {
  Flux.dispatch(actionTypes.REMOVE_EMITTER_HANDLER, {
    token: token,
  });
};

/**
 * @param {EmitterEvent} event
 * @param {boolean} [isInternal] - if true will not trigger publicOnly event handlers
 * @param {boolean} [suppressErrors] - if true will not emit an event on error
 */
exports.emit = function(event:EmitterEvent, isInternal?:boolean, suppressErrors?:boolean) {
  if (__INVARIANT__) {
    require('../utils/invariant').isType('EmitterEvent', event);
  }

  var handlerConfigs = EventEmitterStore.getHandlers(event, isInternal);

  _.each(handlerConfigs, function(handlerConfig) {
    try {
      handlerConfig.handler.call({ $di: di }, event);
    } catch(e) {
      if (!suppressErrors && handlerConfig.emitErrors) {
        Logger.error('Error in handler for event:', event, e);
        ApiEvents.emitError(e, null, isInternal);
      } else {
        Logger.warn('Suppressed error in handler for event:', event, e);
      }
    }
  });
};
